<template>
  <div class="flex flex-col gap-2">
    <NuxtLink :to="{ name: 'index' }">
      <img
        :src="AppLogo"
        class="size-18"
      />
    </NuxtLink>

    <span class="text-base font-medium leading-sm text-secondary line-clamp-1">
      ระบบรับคำสั่งซื้อ Ducking
    </span>
  </div>
</template>

<script lang="ts" setup>
import AppLogo from "@/assets/images/logo.svg";
</script>

<style></style>
